"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AGENT_STATUS_TO_ICON", {
  enumerable: true,
  get: function get() {
    return _constants.AGENT_STATUS_TO_ICON;
  }
});
Object.defineProperty(exports, "AddressInput", {
  enumerable: true,
  get: function get() {
    return _AddressInput["default"];
  }
});
Object.defineProperty(exports, "AdminModal", {
  enumerable: true,
  get: function get() {
    return _AdminModal["default"];
  }
});
Object.defineProperty(exports, "AgentButton", {
  enumerable: true,
  get: function get() {
    return _AgentButton["default"];
  }
});
Object.defineProperty(exports, "AgentState", {
  enumerable: true,
  get: function get() {
    return _AgentState["default"];
  }
});
Object.defineProperty(exports, "AreasItem", {
  enumerable: true,
  get: function get() {
    return _AreasItem["default"];
  }
});
Object.defineProperty(exports, "AreasItemCounter", {
  enumerable: true,
  get: function get() {
    return _AreasItemCounter["default"];
  }
});
Object.defineProperty(exports, "AudioIcon", {
  enumerable: true,
  get: function get() {
    return _AudioIcon["default"];
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button["default"];
  }
});
Object.defineProperty(exports, "ButtonIcon", {
  enumerable: true,
  get: function get() {
    return _ButtonIcon["default"];
  }
});
Object.defineProperty(exports, "ButtonSwitch", {
  enumerable: true,
  get: function get() {
    return _ButtonSwitch["default"];
  }
});
Object.defineProperty(exports, "CampaignIcon", {
  enumerable: true,
  get: function get() {
    return _CampaignIcon["default"];
  }
});
Object.defineProperty(exports, "CampaignIconOption", {
  enumerable: true,
  get: function get() {
    return _CampaignIconOption["default"];
  }
});
Object.defineProperty(exports, "CampaignItem", {
  enumerable: true,
  get: function get() {
    return _CampaignItem["default"];
  }
});
Object.defineProperty(exports, "CampaignItemOption", {
  enumerable: true,
  get: function get() {
    return _CampaignItemOption["default"];
  }
});
Object.defineProperty(exports, "CardFormat", {
  enumerable: true,
  get: function get() {
    return _CardFormat["default"];
  }
});
Object.defineProperty(exports, "Cards", {
  enumerable: true,
  get: function get() {
    return _Cards["default"];
  }
});
Object.defineProperty(exports, "CheckAll", {
  enumerable: true,
  get: function get() {
    return _CheckAll["default"];
  }
});
Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function get() {
    return _Checkbox["default"];
  }
});
Object.defineProperty(exports, "CheckboxGroup", {
  enumerable: true,
  get: function get() {
    return _CheckboxContext["default"];
  }
});
Object.defineProperty(exports, "Chips", {
  enumerable: true,
  get: function get() {
    return _Chips["default"];
  }
});
Object.defineProperty(exports, "ColorPicker", {
  enumerable: true,
  get: function get() {
    return _ColorPicker["default"];
  }
});
Object.defineProperty(exports, "ColorPickerPopover", {
  enumerable: true,
  get: function get() {
    return _ColorPickerPopover["default"];
  }
});
Object.defineProperty(exports, "Column", {
  enumerable: true,
  get: function get() {
    return _Table.Column;
  }
});
Object.defineProperty(exports, "Content", {
  enumerable: true,
  get: function get() {
    return _DropDownMenu.Content;
  }
});
Object.defineProperty(exports, "Counter", {
  enumerable: true,
  get: function get() {
    return _Counter["default"];
  }
});
Object.defineProperty(exports, "CounterFilter", {
  enumerable: true,
  get: function get() {
    return _FilterPopover.CounterFilter;
  }
});
Object.defineProperty(exports, "DatePicker", {
  enumerable: true,
  get: function get() {
    return _DatePickerInput.DatePicker;
  }
});
Object.defineProperty(exports, "DatePickerInput", {
  enumerable: true,
  get: function get() {
    return _DatePickerInput["default"];
  }
});
Object.defineProperty(exports, "DialogBox", {
  enumerable: true,
  get: function get() {
    return _DialogBox["default"];
  }
});
Object.defineProperty(exports, "DragNDrop", {
  enumerable: true,
  get: function get() {
    return _DragNDrop["default"];
  }
});
Object.defineProperty(exports, "DragNDropWrapper", {
  enumerable: true,
  get: function get() {
    return _DragNDropWrapper["default"];
  }
});
Object.defineProperty(exports, "DropDown", {
  enumerable: true,
  get: function get() {
    return _DropDown["default"];
  }
});
Object.defineProperty(exports, "DropDownMenu", {
  enumerable: true,
  get: function get() {
    return _DropDownMenu["default"];
  }
});
Object.defineProperty(exports, "FilterInput", {
  enumerable: true,
  get: function get() {
    return _FilterInput["default"];
  }
});
Object.defineProperty(exports, "FilterPopover", {
  enumerable: true,
  get: function get() {
    return _FilterPopover["default"];
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _DropDownMenu.Header;
  }
});
Object.defineProperty(exports, "IconItem", {
  enumerable: true,
  get: function get() {
    return _IconItem["default"];
  }
});
Object.defineProperty(exports, "IconItemList", {
  enumerable: true,
  get: function get() {
    return _IconItemList["default"];
  }
});
Object.defineProperty(exports, "InputChip", {
  enumerable: true,
  get: function get() {
    return _InputChip["default"];
  }
});
Object.defineProperty(exports, "InputFileUpload", {
  enumerable: true,
  get: function get() {
    return _InputFileUpload["default"];
  }
});
Object.defineProperty(exports, "ItemFilter", {
  enumerable: true,
  get: function get() {
    return _FilterPopover.ItemFilter;
  }
});
Object.defineProperty(exports, "ItemSelectContext", {
  enumerable: true,
  get: function get() {
    return _ItemSelectContext["default"];
  }
});
Object.defineProperty(exports, "LabelInput", {
  enumerable: true,
  get: function get() {
    return _LabelInput["default"];
  }
});
Object.defineProperty(exports, "ListDropDown", {
  enumerable: true,
  get: function get() {
    return _ListDropDown["default"];
  }
});
Object.defineProperty(exports, "ListFilter", {
  enumerable: true,
  get: function get() {
    return _FilterPopover.ListFilter;
  }
});
Object.defineProperty(exports, "ListInput", {
  enumerable: true,
  get: function get() {
    return _ListInput["default"];
  }
});
Object.defineProperty(exports, "ListItem", {
  enumerable: true,
  get: function get() {
    return _ListDropDown.ListItem;
  }
});
Object.defineProperty(exports, "LoadingBar", {
  enumerable: true,
  get: function get() {
    return _LoadingBar["default"];
  }
});
Object.defineProperty(exports, "Menu", {
  enumerable: true,
  get: function get() {
    return _MenuBar.Menu;
  }
});
Object.defineProperty(exports, "MenuBar", {
  enumerable: true,
  get: function get() {
    return _MenuBar["default"];
  }
});
Object.defineProperty(exports, "MenuItem", {
  enumerable: true,
  get: function get() {
    return _MenuBar.MenuItem;
  }
});
Object.defineProperty(exports, "MessageInput", {
  enumerable: true,
  get: function get() {
    return _MessageInput["default"];
  }
});
Object.defineProperty(exports, "NotFoundException", {
  enumerable: true,
  get: function get() {
    return _exceptions.NotFoundException;
  }
});
Object.defineProperty(exports, "NotificationCounter", {
  enumerable: true,
  get: function get() {
    return _NotificationCounter["default"];
  }
});
Object.defineProperty(exports, "Option", {
  enumerable: true,
  get: function get() {
    return _DropDownMenu.Option;
  }
});
Object.defineProperty(exports, "OutsideClickWrapper", {
  enumerable: true,
  get: function get() {
    return _OutsideClickWrapper["default"];
  }
});
Object.defineProperty(exports, "PrimaryTab", {
  enumerable: true,
  get: function get() {
    return _Tab["default"];
  }
});
Object.defineProperty(exports, "RadioButton", {
  enumerable: true,
  get: function get() {
    return _RadioButton["default"];
  }
});
Object.defineProperty(exports, "RangeFilter", {
  enumerable: true,
  get: function get() {
    return _FilterPopover.RangeFilter;
  }
});
Object.defineProperty(exports, "RatingStars", {
  enumerable: true,
  get: function get() {
    return _RatingStars["default"];
  }
});
Object.defineProperty(exports, "RequestException", {
  enumerable: true,
  get: function get() {
    return _exceptions.RequestException;
  }
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _Table.Row;
  }
});
Object.defineProperty(exports, "SearchSelection", {
  enumerable: true,
  get: function get() {
    return _SearchSelection["default"];
  }
});
Object.defineProperty(exports, "SearchSelectionAgent", {
  enumerable: true,
  get: function get() {
    return _SearchSelectionAgent["default"];
  }
});
Object.defineProperty(exports, "SecondaryTab", {
  enumerable: true,
  get: function get() {
    return _Tab2["default"];
  }
});
Object.defineProperty(exports, "Select", {
  enumerable: true,
  get: function get() {
    return _Select["default"];
  }
});
Object.defineProperty(exports, "SelectListItem", {
  enumerable: true,
  get: function get() {
    return _SelectListItem["default"];
  }
});
Object.defineProperty(exports, "SelectOptionIcon", {
  enumerable: true,
  get: function get() {
    return _Select.SelectOptionIcon;
  }
});
Object.defineProperty(exports, "SideBarTab", {
  enumerable: true,
  get: function get() {
    return _Tab3["default"];
  }
});
Object.defineProperty(exports, "SimpleLineChart", {
  enumerable: true,
  get: function get() {
    return _SimpleLineChart["default"];
  }
});
Object.defineProperty(exports, "SimplePieChart", {
  enumerable: true,
  get: function get() {
    return _SimplePieChart["default"];
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider["default"];
  }
});
Object.defineProperty(exports, "SubMenu", {
  enumerable: true,
  get: function get() {
    return _MenuBar.SubMenu;
  }
});
Object.defineProperty(exports, "Switch", {
  enumerable: true,
  get: function get() {
    return _Switch["default"];
  }
});
Object.defineProperty(exports, "TabPanel", {
  enumerable: true,
  get: function get() {
    return _TabPanel["default"];
  }
});
Object.defineProperty(exports, "Table", {
  enumerable: true,
  get: function get() {
    return _Table["default"];
  }
});
Object.defineProperty(exports, "TextFilter", {
  enumerable: true,
  get: function get() {
    return _FilterPopover.TextFilter;
  }
});
Object.defineProperty(exports, "TimePicker", {
  enumerable: true,
  get: function get() {
    return _TimePicker["default"];
  }
});
Object.defineProperty(exports, "Toast", {
  enumerable: true,
  get: function get() {
    return _Toast["default"];
  }
});
Object.defineProperty(exports, "ToastConsumer", {
  enumerable: true,
  get: function get() {
    return _Toasts.ToastConsumer;
  }
});
Object.defineProperty(exports, "ToastProvider", {
  enumerable: true,
  get: function get() {
    return _Toasts.ToastProvider;
  }
});
Object.defineProperty(exports, "ToggleChip", {
  enumerable: true,
  get: function get() {
    return _ToggleChip["default"];
  }
});
Object.defineProperty(exports, "UNAVAILABLE_ICONS", {
  enumerable: true,
  get: function get() {
    return _UnavailableIcon.UNAVAILABLE_ICONS;
  }
});
Object.defineProperty(exports, "UNAVAILABLE_ICONS_DICTIONARY", {
  enumerable: true,
  get: function get() {
    return _UnavailableIcon.UNAVAILABLE_ICONS_DICTIONARY;
  }
});
Object.defineProperty(exports, "UnavailableIcon", {
  enumerable: true,
  get: function get() {
    return _UnavailableIcon["default"];
  }
});
Object.defineProperty(exports, "WGResourceItem", {
  enumerable: true,
  get: function get() {
    return _WGResourceItem["default"];
  }
});
Object.defineProperty(exports, "WizardProgressBar", {
  enumerable: true,
  get: function get() {
    return _WizardProgress["default"];
  }
});
Object.defineProperty(exports, "WizardStep", {
  enumerable: true,
  get: function get() {
    return _WizardProgress.WizardStep;
  }
});
Object.defineProperty(exports, "classNames", {
  enumerable: true,
  get: function get() {
    return _classNames["default"];
  }
});
Object.defineProperty(exports, "formatDateForRequest", {
  enumerable: true,
  get: function get() {
    return _formatters.formatDateForRequest;
  }
});
Object.defineProperty(exports, "formatDateLongYear", {
  enumerable: true,
  get: function get() {
    return _formatters.formatDateLongYear;
  }
});
Object.defineProperty(exports, "formatDateShort", {
  enumerable: true,
  get: function get() {
    return _formatters.formatDateShort;
  }
});
Object.defineProperty(exports, "formatDateShortTwoDigits", {
  enumerable: true,
  get: function get() {
    return _formatters.formatDateShortTwoDigits;
  }
});
Object.defineProperty(exports, "formatDateWithHour", {
  enumerable: true,
  get: function get() {
    return _formatters.formatDateWithHour;
  }
});
Object.defineProperty(exports, "formatDatetimeForRequest", {
  enumerable: true,
  get: function get() {
    return _formatters.formatDatetimeForRequest;
  }
});
Object.defineProperty(exports, "formatTime", {
  enumerable: true,
  get: function get() {
    return _formatters.formatTime;
  }
});
Object.defineProperty(exports, "formatTimeShort", {
  enumerable: true,
  get: function get() {
    return _formatters.formatTimeShort;
  }
});
Object.defineProperty(exports, "getSizeString", {
  enumerable: true,
  get: function get() {
    return _formatters.getSizeString;
  }
});
Object.defineProperty(exports, "getTime", {
  enumerable: true,
  get: function get() {
    return _helpers.getTime;
  }
});
Object.defineProperty(exports, "isValidDate", {
  enumerable: true,
  get: function get() {
    return _helpers.isValidDate;
  }
});
Object.defineProperty(exports, "isValidMail", {
  enumerable: true,
  get: function get() {
    return _helpers.isValidMail;
  }
});
Object.defineProperty(exports, "isValidTime", {
  enumerable: true,
  get: function get() {
    return _helpers.isValidTime;
  }
});
Object.defineProperty(exports, "itemselectContext", {
  enumerable: true,
  get: function get() {
    return _ItemSelectContext.Context;
  }
});
Object.defineProperty(exports, "range", {
  enumerable: true,
  get: function get() {
    return _util.range;
  }
});
Object.defineProperty(exports, "removeFromObject", {
  enumerable: true,
  get: function get() {
    return _helpers.removeFromObject;
  }
});
Object.defineProperty(exports, "updateArrayImmutably", {
  enumerable: true,
  get: function get() {
    return _helpers.updateArrayImmutably;
  }
});
Object.defineProperty(exports, "useInfiniteScroll", {
  enumerable: true,
  get: function get() {
    return _hooks.useInfiniteScroll;
  }
});
Object.defineProperty(exports, "useInfiniteScrollWithRefCallback", {
  enumerable: true,
  get: function get() {
    return _hooks.useInfiniteScrollWithRefCallback;
  }
});
Object.defineProperty(exports, "useLatest", {
  enumerable: true,
  get: function get() {
    return _hooks.useLatest;
  }
});
Object.defineProperty(exports, "useOutsideClick", {
  enumerable: true,
  get: function get() {
    return _hooks.useOutsideClick;
  }
});
Object.defineProperty(exports, "usePrevious", {
  enumerable: true,
  get: function get() {
    return _hooks.usePrevious;
  }
});
Object.defineProperty(exports, "useScaledBottomLimit", {
  enumerable: true,
  get: function get() {
    return _hooks.useScaledBottomLimit;
  }
});
Object.defineProperty(exports, "useScaledRightLimit", {
  enumerable: true,
  get: function get() {
    return _hooks.useScaledRightLimit;
  }
});
Object.defineProperty(exports, "useStopWatchBasic", {
  enumerable: true,
  get: function get() {
    return _index.useStopWatchBasic;
  }
});
Object.defineProperty(exports, "useStopWatchCountDown", {
  enumerable: true,
  get: function get() {
    return _index.useStopWatchCountDown;
  }
});
Object.defineProperty(exports, "useStopWatchInterval", {
  enumerable: true,
  get: function get() {
    return _index.useStopWatchInterval;
  }
});
Object.defineProperty(exports, "useStopWatchWorker", {
  enumerable: true,
  get: function get() {
    return _index.useStopWatchWorker;
  }
});
Object.defineProperty(exports, "useToasts", {
  enumerable: true,
  get: function get() {
    return _Toasts.useToasts;
  }
});
Object.defineProperty(exports, "useUpdateEffect", {
  enumerable: true,
  get: function get() {
    return _hooks.useUpdateEffect;
  }
});

var _AudioIcon = _interopRequireDefault(require("./components/AudioIcon/AudioIcon"));

var _Button = _interopRequireDefault(require("./components/Button/Button"));

var _ButtonIcon = _interopRequireDefault(require("./components/ButtonIcon/ButtonIcon"));

var _Chips = _interopRequireDefault(require("./components/Chips/Chips"));

var _DatePickerInput = _interopRequireWildcard(require("./components/DatePickerInput/DatePickerInput"));

var _DialogBox = _interopRequireDefault(require("./components/DialogBox/DialogBox"));

var _DropDownMenu = _interopRequireWildcard(require("./components/DropDownMenu/DropDownMenu"));

var _IconItem = _interopRequireDefault(require("./components/IconItem/IconItem"));

var _IconItemList = _interopRequireDefault(require("./components/IconItem/IconItemList"));

var _Checkbox = _interopRequireDefault(require("./components/Input/CheckBox/Checkbox"));

var _CheckAll = _interopRequireDefault(require("./components/Input/CheckBox/CheckAll"));

var _CheckboxContext = _interopRequireDefault(require("./components/Input/CheckBox/CheckboxContext"));

var _FilterInput = _interopRequireDefault(require("./components/Input/FilterInput/FilterInput"));

var _FilterPopover = _interopRequireWildcard(require("./components/FilterPopover/FilterPopover"));

var _DropDown = _interopRequireDefault(require("./components/DropDown/DropDown"));

var _NotificationCounter = _interopRequireDefault(require("./components/NotificationCounter/NotificationCounter"));

var _Tab = _interopRequireDefault(require("./components/Tab/Primary/Tab"));

var _Tab2 = _interopRequireDefault(require("./components/Tab/Secondary/Tab"));

var _Tab3 = _interopRequireDefault(require("./components/Tab/SideBarTab/Tab"));

var _Slider = _interopRequireDefault(require("./components/Slider/Slider"));

var _TabPanel = _interopRequireDefault(require("./components/Tab/TabPanel"));

var _ItemSelectContext = _interopRequireWildcard(require("./hooks/itemSelect/ItemSelectContext"));

var _Toasts = require("./components/Toasts/Toasts");

var _Toast = _interopRequireDefault(require("./components/Toasts/Toast"));

var _LabelInput = _interopRequireDefault(require("./components/Input/LabelInput/LabelInput"));

var _Table = _interopRequireWildcard(require("./components/Table/Table"));

var _CampaignItem = _interopRequireDefault(require("./components/CampaignItem/CampaignItem"));

var _ListDropDown = _interopRequireWildcard(require("./components/ListDropDown/ListDropDown"));

var _DragNDropWrapper = _interopRequireDefault(require("./components/DragNDropWrapper/DragNDropWrapper"));

var _DragNDrop = _interopRequireDefault(require("./components/DragNDrop/DragNDrop"));

var _OutsideClickWrapper = _interopRequireDefault(require("./components/OutsideClickWrapper/OutsideClickWrapper"));

var _index = require("./components/StopWatch/index");

var _formatters = require("./util/formatters");

var _helpers = require("./util/helpers");

var _util = require("./util");

var _exceptions = require("./util/exceptions");

var _AgentState = _interopRequireDefault(require("./components/AgentState/AgentState"));

var _Switch = _interopRequireDefault(require("./components/Switch/Switch"));

var _Counter = _interopRequireDefault(require("./components/Counter/Counter"));

var _Cards = _interopRequireDefault(require("./components/Cards/Cards"));

var _CardFormat = _interopRequireDefault(require("./components/Cards/CardFormat"));

var _AreasItem = _interopRequireDefault(require("./components/AreasItem/AreasItem"));

var _AreasItemCounter = _interopRequireDefault(require("./components/AreasItem/AreasItemCounter"));

var _ToggleChip = _interopRequireDefault(require("./components/ToggleChip/ToggleChip"));

var _InputChip = _interopRequireDefault(require("./components/InputChip/InputChip"));

var _ListInput = _interopRequireDefault(require("./components/AddressInput/ListInput"));

var _AddressInput = _interopRequireDefault(require("./components/AddressInput/AddressInput"));

var _MenuBar = _interopRequireWildcard(require("./components/MenuBar/MenuBar"));

var _SimpleLineChart = _interopRequireDefault(require("./components/SimpleLineChart/SimpleLineChart"));

var _SimplePieChart = _interopRequireDefault(require("./components/SimplePieChart/SimplePieChart"));

var _hooks = require("./util/hooks");

var _SelectListItem = _interopRequireDefault(require("./components/SelectListItem/SelectListItem"));

var _RadioButton = _interopRequireDefault(require("./components/RadioButton/RadioButton"));

var _TimePicker = _interopRequireDefault(require("./components/TimePicker/TimePicker"));

var _WGResourceItem = _interopRequireDefault(require("./components/WGResourceItem/WGResourceItem"));

var _LoadingBar = _interopRequireDefault(require("./components/LoadingBar/LoadingBar"));

var _CampaignItemOption = _interopRequireDefault(require("./components/CampaignItemOption/CampaignItemOption"));

var _CampaignIconOption = _interopRequireDefault(require("./components/CampaignIconOption/CampaignIconOption"));

var _WizardProgress = _interopRequireWildcard(require("./components/WizardProgress/WizardProgress"));

var _RatingStars = _interopRequireDefault(require("./components/RatingStars/RatingStars"));

var _Select = _interopRequireWildcard(require("./components/Select/Select"));

var _UnavailableIcon = _interopRequireWildcard(require("./components/UnavailableIcon/UnavailableIcon"));

var _ColorPickerPopover = _interopRequireDefault(require("./components/ColorPicker/ColorPickerPopover"));

var _ColorPicker = _interopRequireDefault(require("./components/ColorPicker/ColorPicker"));

var _constants = require("./util/constants");

var _classNames = _interopRequireDefault(require("./util/classNames"));

var _SearchSelection = _interopRequireDefault(require("./components/SearchSelection/SearchSelection"));

var _ButtonSwitch = _interopRequireDefault(require("./components/ButtonSwitch/ButtonSwitch"));

var _AgentButton = _interopRequireDefault(require("./components/AgentButtons/AgentButton"));

var _InputFileUpload = _interopRequireDefault(require("./components/Input/InputFileUpload/InputFileUpload"));

var _AdminModal = _interopRequireDefault(require("./components/AdminModal/AdminModal"));

var _CampaignIcon = _interopRequireDefault(require("./components/CampaignIcon/CampaignIcon"));

var _MessageInput = _interopRequireDefault(require("./components/Input/MessageInput/MessageInput"));

var _SearchSelectionAgent = _interopRequireDefault(require("./components/SearchSelectionAgent/SearchSelectionAgent"));

require("./styles/bundle.css");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}